import queryString from 'query-string';

import { api } from '../api';

const enhancedApi = api.enhanceEndpoints({
  addTagTypes: ['DiscoverCompanies'],
});

export type DiscoverCompanyType = {
  domain: string;
  logo: string | null;
  name: string;
};
export type GetDiscoverCompaniesResponse = {
  items: DiscoverCompanyType[];
};

type GetDiscoverCompaniesRequestQuery = {
  name: string;
};

const extendedApi = enhancedApi.injectEndpoints({
  endpoints: (build) => ({
    getDiscoverCompanies: build.query<
      GetDiscoverCompaniesResponse,
      GetDiscoverCompaniesRequestQuery
    >({
      providesTags: ['DiscoverCompanies'],
      query: (params) =>
        `discover/companies.json?${queryString.stringify(params)}`,
    }),
  }),
});

export const { useGetDiscoverCompaniesQuery } = extendedApi;
export const discoverApi = extendedApi;
